module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row color-row-4"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "txt-row-4"
  }, [_c('h3', [_vm._v("Se você não quer se preocupar com recargas ou saldo insuficiente, este é o seu plano.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/adesao?planId=45",
      "tag": "button"
    }
  }, [_vm._v("\n          Quero este plano!\n        ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('router-link', {
    staticClass: "btn btn-back",
    attrs: {
      "to": "/sodre"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n        Voltar para planos\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 text-right padding-left-zero"
  }, [_c('router-link', {
    staticClass: "btn btn-back",
    attrs: {
      "to": "/sodre"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n        Ver plano anterior\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-back back-plan",
    attrs: {
      "to": "/sodre"
    }
  }, [_vm._v("\n        Ver próximo plano\n        "), _c('i', {
    staticClass: "icon-circle-right align-icon-right"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Serviços para Você")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 margin-b10"
  }, [_c('h3', {
    staticClass: "bold upper"
  }, [_vm._v("Plano Pré-pago Automático")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row color-row-1"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "txt-row-1"
  }, [_c('span', [_vm._v("No "), _c('b', [_vm._v("PRÉ-PAGO AUTOMÁTICO")]), _vm._v(" você determina qual vai ser o valor da recarga automática (R$ 50,00 por exemplo), e toda vez que o seu saldo atingir 40% desse valor (no caso de R$ 50,00 será R$ 20,00), nós realizamos uma nova recarga automaticamente para você.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "recharge-auto"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row color-row-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "payment-methods-confort"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "txt-row-2"
  }, [_c('p', [_vm._v("A recarga automática é feita pela forma de pagamento que você cadastrou.")]), _vm._v(" "), _c('p', [_vm._v("Nossa taxa é a "), _c('b', [_vm._v("menor do mercado")]), _vm._v(" e quanto maior o valor da recarga menor é a porcentagem da taxa de recarga.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row color-row-3"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "txt-row-3"
  }, [_c('span', [_vm._v("Você pode ainda consultar "), _c('b', [_vm._v("saldos")]), _vm._v(", "), _c('b', [_vm._v("extratos")]), _vm._v(" e "), _c('b', [_vm._v("geolocalização dos veículos")]), _vm._v(" diretamente no nosso site ou no app para mobile (Android e iOS).")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "gps-vehicle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "confort-couch"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-c707b468!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/plan-prepay-auto-sodre.vue
// module id = 2212
// module chunks = 1